import React from 'react';

import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';

import { observer } from 'mobx-react-lite';
import { MarginOrdersType } from 'src/lib/margin/types';

import { MarginPositionsTableData } from './MarginPositionsTable.data';
import { MarginPositionsTableContent } from './MarginPositionsTableContent';
import { useMarginPositionsTableFilterStore } from '../../useMarginPositionsTableFilterStore';
import { MarginPositionsTableFilters } from '../components';

type Props = {
  pageSize?: number;
  ordersType: MarginOrdersType;
  className?: string;
  hideHeader?: boolean;
  showFilter?: boolean;
  groupBy?: keyof MarginPositionsTableData;
  sortKey?: keyof MarginPositionsTableData;
  isSm?: boolean;
  isXs?: boolean;
};

const MarginPositionsTable: React.FC<Props> = observer(
  ({ pageSize = 300, className, ordersType, hideHeader = false, showFilter = false, groupBy, sortKey, isSm, isXs }) => {
    const { filterCurrentInstrument, setFilterCurrentInstrument } = useMarginPositionsTableFilterStore();

    return (
      <FlexLayout direction='column' className='h-full w-full overflow-hidden'>
        <MarginPositionsTableFilters
          show={showFilter}
          instrument={filterCurrentInstrument}
          setInstrument={setFilterCurrentInstrument}
        />
        <MarginPositionsTableContent
          pageSize={pageSize}
          className={className}
          ordersType={ordersType}
          hideHeader={hideHeader}
          groupBy={groupBy}
          sortKey={sortKey}
          isSm={isSm}
          isXs={isXs}
        />
      </FlexLayout>
    );
  },
);

export { MarginPositionsTable };
